import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=a1efc7e0&scoped=true"
var script = {}
import style0 from "./preloader.vue?vue&type=style&index=0&id=a1efc7e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1efc7e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VProgressCircular: require('/app/node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
